import React from 'react';

import { Column, Grid, Row } from '@husslehq/ui-library';

import styles from './HowToGetStartedCorporate.module.scss';

export const HowToGetStartedCorporate: React.FC = () => {
  return (
    <section className={styles.howtogetstarted}>
      <Grid>
        <Row>
          <Column xs="12" md="7" className={styles['howtogetstarted__content-body']}>
            <h2>How to get started with your Hussle corporate membership</h2>
            <ol className={styles['howtogetstarted__content-body-steps']}>
              <li>
                <h4 className={styles['howtogetstarted__content-body-steps-heading']}>Choose a gym</h4>
                <p className={styles['howtogetstarted__content-body-steps-content']}>
                  Purchase a discounted monthly pass by selecting the gym you want to go to the most
                </p>
              </li>
              <li>
                <h4 className={styles['howtogetstarted__content-body-steps-heading']}>Get your pass - workout!</h4>
                <p className={styles['howtogetstarted__content-body-steps-content']}>
                  You will be sent a unique code which you use to access the gym - simply show this at reception
                </p>
              </li>
              <li>
                <h4 className={styles['howtogetstarted__content-body-steps-heading']}>Try something new</h4>
                <p className={styles['howtogetstarted__content-body-steps-content']}>
                  Your pass gives you access to your chosen venue and all others which are at the same price point or
                  less
                </p>
              </li>
              <li>
                <h4 className={styles['howtogetstarted__content-body-steps-heading']}>Total flexibility</h4>
                <p className={styles['howtogetstarted__content-body-steps-content']}>
                  If life changes you can cancel at any time and come back when you are ready
                </p>
              </li>
            </ol>
          </Column>
          <Column xs="12" md="5">
            <div className={styles['howtogetstarted__content-image']}>&nbsp;</div>
          </Column>
        </Row>
      </Grid>
    </section>
  );
};
